import NewsletterSubscribePopup from './NewsletterSubscribePopup.vue';

const div = document.createElement('div');
$(document.body).append(div);

const newsletterSubscribePopup = new NewsletterSubscribePopup();
newsletterSubscribePopup.$mount(div);
